// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"f04ffce5","147":"9fe9b391","156":"097d0179","438":"39bbd81a","706":"42d36951","726":"6c678e1f"}[chunkId] + ".chunk.js";
};